import React from 'react'
import { TabNav } from '~/components/shared/TabNav'
import TabNavButtons from './TabNavButtons'
import TabNavPanelContainer from './TabNavPanelContainer'
import CoachDashboardProvider from './CoachDashboardProvider'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'

const CoachDashboard = () => {
  return (
    <div>
      <TabNav defaultActiveTab="prioritized_tasks" mobileMode="dropdown">
        <TabNavButtons />
        <TabNavPanelContainer />
      </TabNav>
    </div>
  )
}

const Index = ({ locale, ...props }) => {
  const { current_user } = props
  return (
    <TranslationProvider
      locale={current_user.locale}
      translations={translations}
      scope={'javascript.components.CoachDashboard'}
    >
      <CoachDashboardProvider {...props}>
        <CoachDashboard />
      </CoachDashboardProvider>
    </TranslationProvider>
  )
}
export default Index
